<template lang="html">
  <section class="app-update-news">
    <p class="text-success" v-if="messageSubmission">
      <strong>{{ messageSubmission }}</strong>
    </p>
    <p v-if="!getCurrentElement">
      Please go first to the "<a href="#" @click="navigateAway('read')"><strong><em>Read</em></strong></a>"
      tab and select the award you would like to update.
    </p>
    <form v-else @submit.prevent="onSubmit" class="text-left" :class="$v.dataForm.$invalid ? '':'was-validated'">
      <div class="form-group d-flex">
        <label for="newsDatePublished" class="w-25 align-self-center">* Date published :</label>
        <div class="w-100">
          <input @blur="$v.dataForm.newsDatePublished.$touch()" v-model="dataForm.newsDatePublished"
                 :class="$v.dataForm.newsDatePublished.$error ? 'is-invalid': ''" id="newsDatePublished"
                 type="date" class="form-control">
          <div class="invalid-feedback">Please enter date of publication !</div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="newsTitle" class="w-25 align-self-center">* Title :</label>
        <div class="w-100">
          <input @blur="$v.dataForm.newsTitle.$touch() || (dataForm.newsTitle = (dataForm.newsTitle === '') ? savedData.title : dataForm.newsTitle)"
                 v-model="dataForm.newsTitle"
                 :class="$v.dataForm.newsTitle.$error ? 'is-invalid': ''" id="newsTitle"
                 type="text" class="form-control">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.newsTitle.required">Please enter the title of the news !</div>
            <div v-if="!$v.dataForm.newsTitle.minLength">
              News title is too short and may not be correct !
              Enter at least {{$v.dataForm.newsTitle.$params.minLength.min}} letters.
            </div>
            <div v-if="!$v.dataForm.newsTitle.maxLength">
              News title is too long ({{$v.dataForm.newsTitle.$params.maxLength.max}} letters) ! Try to make it short !
            </div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="newsContent" class="w-25 align-self-center">Content :</label>
        <div class="w-100">
          <textarea @blur="$v.dataForm.newsContent.$touch() || (dataForm.newsContent = (dataForm.newsContent === '') ? savedData.content : dataForm.newsContent)"
                    v-model="dataForm.newsContent"
                    :class="$v.dataForm.newsContent.$error ? 'is-invalid': ''" class="form-control"
                    rows="5" id="newsContent" placeholder="Enter text here...">
          </textarea>
          <div class="invalid-feedback">
            The content of the news must not have less than {{$v.dataForm.newsContent.$params.minLength.min}} letters !
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="newsAuthor" class="w-25 align-self-center">* Author :</label>
        <div class="w-100">
          <input @blur="$v.dataForm.newsAuthor.$touch() || (dataForm.newsAuthor = (dataForm.newsAuthor === '') ? savedData.author : dataForm.newsAuthor)"
                 v-model="dataForm.newsAuthor"
                 :class="$v.dataForm.newsAuthor.$error ? 'is-invalid': ''" type="text"
                 class="form-control" id="newsAuthor">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.newsAuthor.required">Please enter the author of the news !</div>
            <div v-if="!$v.dataForm.newsAuthor.minLength">
              Author name is too short and may not be correct !
              Enter at least {{$v.dataForm.newsAuthor.$params.minLength.min}} letters.
            </div>
            <div v-if="!$v.dataForm.newsAuthor.maxLength">
              Author name is too long ({{$v.dataForm.newsAuthor.$params.maxLength.max}} letters) ! Try to make it short !
            </div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="newsSrc" class="w-25 align-self-center">Source :</label>
        <div class="w-100">
          <input @blur="$v.dataForm.newsSrc.$touch() || (dataForm.newsSrc = (dataForm.newsSrc === '') ? savedData.src : dataForm.newsSrc)"
                 v-model="dataForm.newsSrc"
                 :class="$v.dataForm.newsSrc.$error ? 'is-invalid': ''" type="text"
                 class="form-control" id="newsSrc">
          <div class="invalid-feedback">Try to shorten the source ! It's too long
            ({{$v.dataForm.newsSrc.$params.maxLength.max}})
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="newsLink" class="w-25 align-self-center">Link :</label>
        <div class="w-100">
          <input @blur="$v.dataForm.newsLink.$touch() || (dataForm.newsLink = (dataForm.newsLink === '') ? savedData.link : dataForm.newsLink)"
                 v-model="dataForm.newsLink"
                 :class="$v.dataForm.newsLink.$error ? 'is-invalid': ''" type="url"
                 class="form-control" id="newsLink">
          <div class="invalid-feedback">Try to shorten the link ! It's too long
            ({{$v.dataForm.newsLink.$params.maxLength.max}} characters)
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="newsTypeId" class="w-25 align-self-center">* Type :</label>
        <div class="w-100">
          <select @blur="$v.dataForm.newsTypeId.$touch()" v-model="dataForm.newsTypeId" id="newsTypeId"
                  :class="$v.dataForm.newsTypeId.$error ? 'is-invalid': ''" class="custom-select">
            <option :value="news_type.news_type_id" :key="news_type.news_type_id" class="text-capitalize"
                    v-for="news_type of getNewsTypes">
              {{ news_type.type }}
            </option>
          </select>
          <div class="invalid-feedback">Please choose type of news !</div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="newsOverview" class="w-25 align-self-center">* Overview :</label>
        <div class="w-100">
          <textarea @blur="$v.dataForm.newsOverview.$touch() || (dataForm.newsOverview = (dataForm.newsOverview === '') ? savedData.overview : dataForm.newsOverview)"
                    v-model="dataForm.newsOverview"
                    :class="$v.dataForm.newsOverview.$error ? 'is-invalid': ''" class="form-control"
                    id="newsOverview" placeholder="Enter text here...">
          </textarea>
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.newsOverview.required">Please enter news overview!</div>
            <div v-if="!$v.dataForm.newsOverview.minLength">
              News overview is too short (less than {{$v.dataForm.newsOverview.$params.minLength.min}} letters) !
            </div>
            <div v-if="!$v.dataForm.newsOverview.maxLength">
              News overview is too long (more than {{$v.dataForm.newsOverview.$params.maxLength.max}} letters) ! Try to make it short !
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 mb-4 text-center">
        <button :class="$v.dataForm.$invalid ? 'cursor-pointer-disabled':''"
                :disabled="$v.dataForm.$invalid" type="submit" class="btn btn-success">
          Submit
        </button>
        <button type="button" class="btn btn-danger ml-3" @click="resetForm">
          Reset
        </button>
      </div>
    </form>
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from "vuex";
import {FORM_NEWS_VALIDATIONS} from '../../validations/formNews'
export default {
  name: 'UpdateNews',
  props: [],
  mounted () {},
  created () {
    this.axiosGet({component: 'news_types', state: 'listNewsTypes'});
    this.readOneData()
      .then(data => {
        this.savedData = data;
        this.dataForm.newsTypeId = this.savedData.news_type_id;
        this.dataForm.newsTitle = this.savedData.title;
        this.dataForm.newsDatePublished = this.savedData.date_published;
        this.dataForm.newsContent = this.savedData.content;
        this.dataForm.newsAuthor = this.savedData.author;
        this.dataForm.newsSrc = this.savedData.src;
        this.dataForm.newsLink = this.savedData.link;
        this.dataForm.newsOverview = this.savedData.overview;
      })
      .catch()
  },
  validations: FORM_NEWS_VALIDATIONS,
  data () {
    return {
      savedData : null,
      dataForm: {
        newsTypeId : undefined,
        newsTitle : undefined,
        newsDatePublished : undefined,
        newsContent : undefined,
        newsAuthor : undefined,
        newsSrc : undefined,
        newsLink : undefined,
        newsOverview : undefined
      },
      messageSubmission: ""
    }
  },
  methods: {
    ...mapActions([
      'setOperation',
      'setCrudComponent',
      'readOneData',
      'updateData',
      'axiosGet'
    ]),
    navigateAway(tab) {
      this.setOperation(tab);
      this.setCrudComponent('app-' + tab + '-' + this.getComponent);
    },
    onSubmit () {
      const formData = {
        news_id : (this.getCurrentElement) ? this.getCurrentElement.id : '',
        news_type_id: this.dataForm.newsTypeId,
        title : this.dataForm.newsTitle,
        date_published: this.dataForm.newsDatePublished,
        content: this.dataForm.newsContent,
        author: this.dataForm.newsAuthor,
        src: this.dataForm.newsSrc,
        link: this.dataForm.newsLink,
        overview: this.dataForm.newsOverview
      };
      this.updateData(formData)
        .then(data => {
          this.messageSubmission = data;
          setTimeout( () => this.messageSubmission = '', 5000);
        })
        .catch()
    },
    resetForm () {
      this.dataForm.newsTypeId = this.savedData.news_type_id;
      this.dataForm.newsTitle = this.savedData.title;
      this.dataForm.newsDatePublished = this.savedData.date_published;
      this.dataForm.newsContent = this.savedData.content;
      this.dataForm.newsAuthor = this.savedData.author;
      this.dataForm.newsSrc = this.savedData.src;
      this.dataForm.newsLink = this.savedData.link;
      this.dataForm.newsOverview = this.savedData.overview;
    }
  },
  computed: {
    ...mapGetters([
      'getComponent',
      'getNewsTypes',
      'getCurrentElement'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-update-news {}
</style>



// WEBPACK FOOTER //
// src/components/news/UpdateNews.vue